import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "a0eaf1a4-2307-43de-9723-bdedb41382dc",
    content: "Speech without mask in reverberant room",
    options: { buttonText: "play sample", audio: `${config.ASSETS_URL}/02/21/task/task-1-sound-1.wav` },
  },
  {
    id: "ae6a3b6e-7bea-4084-9515-d251e879a26e",
    content: "Speech with N-95 mask in reverberant room",
    options: { buttonText: "play sample", audio: `${config.ASSETS_URL}/02/21/task/task-1-sound-2.wav` },
  },
  {
    id: "426fbf60-3397-4f44-bbd0-0ea7745fa287",
    content: "Speech without mask",
    options: { buttonText: "play sample", audio: `${config.ASSETS_URL}/02/21/task/task-1-sound-3.wav` },
  },
  {
    id: "ac508188-bbb8-4068-ab74-7dd39c2a8ec8",
    content: "Speech with N-95 mask",
    options: { buttonText: "play sample", audio: `${config.ASSETS_URL}/02/21/task/task-1-sound-4.wav` },
  },
];

export const task: Task = {
  id: "e3308f86-bd6f-4845-aae8-f0a72911f00e",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["ae6a3b6e-7bea-4084-9515-d251e879a26e"],
};
